import {
  ROUTE_CHANGE,
  FIRST_LOGIN_CHANGE
} from '../actions/types';

const INITIAL_STATE = {
  current_route: localStorage.getItem("lipro_route") || '/',
  is_first_login: false
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case ROUTE_CHANGE:
      return {
        ...state,
        current_route: action.payload.current_route
      };
    case FIRST_LOGIN_CHANGE:
      return {
        ...state,
        is_first_login: action.payload
      }

    default:
      return {
        ...state
      };
  };
};